export const INCIDENTS_DATA_FETCHING = 'INCIDENTS_DATA_FETCHING';
export const INCIDENTS_DATA_FETCHED = 'INCIDENTS_DATA_FETCHED';
export const INCIDENTS_DATA_FETCHING_FAILED = 'INCIDENTS_DATA_FETCHING_FAILED';
export const INCIDENTS_DATA_STATE_ADD="INCIDENTS_DATA_STATE_ADD";
export const INCIDENTS_DATA_STATE_REMOVE="INCIDENTS_DATA_STATE_REMOVE";
export const INCIDENTS_FILTER_STATE="INCIDENTS_FILTER_STATE";
export const INCIDENTS_MAX_NAME_FILTER_ERROR_MESSAGE = "Maximum of 5 words with comma separated is allowed to search";
export const INCIDENTS_MAX_NAME_FILTER_TOOLTIP = "Maximum of 5 words with comma separated shall be allowed to search";
